import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCrcQJyRGTCAnQVoURArnAdMZEJg92IuPI",
  authDomain: "darkcrypto-platform.firebaseapp.com",
  projectId: "darkcrypto-platform",
  storageBucket: "darkcrypto-platform.firebasestorage.app",
  messagingSenderId: "289549512354",
  appId: "1:289549512354:web:f739b8c94ad0c160ea31fb",
  measurementId: "G-CZNZR3NDK8"
};// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Collections names - הוספתי את הקולקשנים החסרים
export const COLLECTIONS = {
  USERS: 'users',
  DEPARTMENTS: 'departments',
  TEAMS: 'teams',                           // חדש - צוותים
  PROJECTS: 'projects',
  TASKS: 'tasks',
  TEMPLATES: 'templates',
  NOTIFICATIONS: 'notifications',
  AUDIT_LOG: 'audit_log',
  STATUS_UPDATES: 'status_updates',
  USER_SETTINGS: 'user_settings',           // חדש - הגדרות משתמש
  NOTIFICATION_RULES: 'notification_rules', // חדש - כללי התראות
  FILES: 'files',                           // חדש - קבצים מועלים
  COMMENTS: 'comments',                     // חדש - הערות במשימות
  DAILY_ROUTINES: 'dailyRoutines',          // חדש - שגרות יומיות
  DAY_OPENINGS: 'dayOpenings',               // חדש - פתיחות יום
  DAY_SUMMARIES: 'daySummaries',
   PERIOD_OPENINGS: 'periodOpenings',
  PERIOD_SUMMARIES: 'periodSummaries'              // חדש - סיכומי יום
};

export default app;